import { useTranslation } from "@next-platform/client-common-core";
import { CapabilityGate, SubCapabilityKey } from "@next-platform/client-common-core/infra/application/capabilities";
import { Filter } from "@next-platform/client-common-spicy-ui";
import React from "react";

import { FilterWrapper } from "@/components/search/FilterWrapper";
import Trans from "@/components/Trans/Trans";

import { DisplayContext } from "../types";
import type { FilterPanelCharacterProps } from "./types";

const FilterPanelCharacterV1 = ({
  context,
  isDesktop,
  isOpen,
  onOpenChange,
  setFeaturesSlot,
  hasFilterDefinition,
  tagsListData,
  tagsActionHandler,
  definitionListData,
  definitionActionHandler,
  languageListData,
  languageActionHandler,
  chatSizeListData,
  chatSizeActionHandler,
}: FilterPanelCharacterProps) => {
  const { t } = useTranslation();

  return (
    <FilterWrapper open={isOpen} onOpenChange={onOpenChange} isDesktop={isDesktop}>
      <div className="grid content-start gap-2.5 h-full w-full">
        <Filter isOpen={true} data={tagsListData} actionHandler={tagsActionHandler}>
          <Filter.Header>
            <Filter.Title>
              <Trans i18nKey="chatbotFilters:filterByTag.title" />
            </Filter.Title>
            <Filter.Reset alwaysShow>
              <Trans i18nKey="common:reset" />
            </Filter.Reset>
          </Filter.Header>
          <Filter.Search children={t("chatbotFilters:filterByTag.placeholder")} />
          <Filter.Body hasExclude />
        </Filter>
        {context !== DisplayContext.MEMBER_SELECT ? <div ref={setFeaturesSlot} className="contents" data-testid="FeaturesFilterSlot" /> : null}
        {!!hasFilterDefinition && (
          <CapabilityGate capability={SubCapabilityKey.DiscoverFilterDefinitionSize}>
            <Filter data={definitionListData} actionHandler={definitionActionHandler} dataTestId="DefinitionSizeCapabilityGate">
              <Filter.Header>
                <Filter.Title>
                  <Trans i18nKey="chatbotFilters:filterByDefinitionSize.title" />
                </Filter.Title>
                <Filter.Reset alwaysShow>
                  <Trans i18nKey="common:reset" />
                </Filter.Reset>
              </Filter.Header>
              <Filter.Body />
            </Filter>
          </CapabilityGate>
        )}
        <CapabilityGate capability={SubCapabilityKey.DiscoverFilterLanguage}>
          <Filter data={languageListData} actionHandler={languageActionHandler} dataTestId="LanguageCapabilityGate">
            <Filter.Header>
              <Filter.Title>
                <Trans i18nKey="chatbotFilters:filterByLanguage.title" />
              </Filter.Title>
              <Filter.Reset alwaysShow>
                <Trans i18nKey="common:reset" />
              </Filter.Reset>
            </Filter.Header>
            <Filter.Search children={t("chatbotFilters:filterByLanguage.placeholder")} />
            <Filter.Body />
          </Filter>
        </CapabilityGate>
        {context !== DisplayContext.MEMBER_SELECT ? (
          <CapabilityGate capability={SubCapabilityKey.DiscoverFilterGroups}>
            <Filter data={chatSizeListData} actionHandler={chatSizeActionHandler} dataTestId="GroupSizeCapabilityGate">
              <Filter.Header>
                <Filter.Title>
                  <Trans i18nKey="chatbotFilters:filterByChatSize.title" />
                </Filter.Title>
                <Filter.Reset alwaysShow>
                  <Trans i18nKey="common:reset" />
                </Filter.Reset>
              </Filter.Header>
              <Filter.Body />
            </Filter>
          </CapabilityGate>
        ) : null}
      </div>
    </FilterWrapper>
  );
};

export default React.memo(FilterPanelCharacterV1);
